import type { SearchType } from '../slices/reviewsApi';
import type { ReviewsFacets } from '../slices/reviewsSearchFilters';
import type { SortOption } from '../types/Reviews';

export const DEFAULT_SORT_OPTION: SortOption = 'atSort';

type GetSearchReviewsArgParams = {
  facets: ReviewsFacets;
  perPage: number;
  searchType: SearchType;
  sortOption: SortOption;
  after?: string;
};

/**
 * Builds the `searchReviews` query arg. Shared so anything seeding the cache ahead of render
 * produces the exact cache key `SearchFilterReviews` looks up on its first render.
 */
const getSearchReviewsArg = ({ after, facets, perPage, searchType, sortOption }: GetSearchReviewsArgParams) => ({
  activity: facets.activities,
  after,
  limit: perPage,
  month: facets.months,
  query: facets.query,
  rating: facets.ratings,
  sortOption,
  ...searchType
});

export default getSearchReviewsArg;
